"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CraftingWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _CraftingWindowModule = _interopRequireDefault(require("./CraftingWindow.module.scss"));

var _ItemPool = _interopRequireDefault(require("../../../entities/ItemPool/ItemPool"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _CraftingWindow = _interopRequireDefault(require("./CraftingWindow.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function CraftingWindow(_ref) {
  var sheet = _ref.sheet,
      tool = _ref.tool,
      _ref$materials = _ref.materials,
      materials = _ref$materials === void 0 ? [] : _ref$materials,
      itemToEnhance = _ref.itemToEnhance,
      onSubmit = _ref.onSubmit,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var handleClickBtnCraft = (0, _react.useCallback)(function () {
    if (onSubmit) onSubmit();
  }, [onSubmit]);
  var renderSheet = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _CraftingWindowModule.default.sheet
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _CraftingWindowModule.default.itemPool
    }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
      sizeX: 2,
      sizeY: 2,
      itemPool: {
        sizeX: 2,
        sizeY: 2,
        items: sheet ? [sheet] : []
      }
    })));
  }, [sheet]);
  var renderTool = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _CraftingWindowModule.default.tool
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _CraftingWindowModule.default.itemPool
    }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
      sizeX: 2,
      sizeY: 2,
      itemPool: {
        sizeX: 2,
        sizeY: 2,
        items: tool ? [tool] : []
      }
    })));
  }, [tool]);
  var renderMaterials = (0, _react.useCallback)(function () {
    var nodes = [];

    for (var i = 0; i <= 5; i++) {
      var material = materials[i];
      var item = material ? material.item : undefined;
      nodes.push( /*#__PURE__*/_react.default.createElement("div", {
        key: i,
        className: (0, _classnames.default)(_CraftingWindowModule.default.material, _CraftingWindowModule.default["material".concat(i + 1)])
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _CraftingWindowModule.default.itemPool
      }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
        sizeX: 2,
        sizeY: 2,
        itemPool: {
          sizeX: 2,
          sizeY: 2,
          items: item ? [item] : []
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: _CraftingWindowModule.default.name
      }, material && material.item.model.name), /*#__PURE__*/_react.default.createElement("div", {
        className: _CraftingWindowModule.default.amount
      }, material && material.amount)));
    }

    return nodes;
  }, [materials]);
  var renderResultingItem = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _CraftingWindowModule.default.resultingItem
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _CraftingWindowModule.default.itemPool
    }, /*#__PURE__*/_react.default.createElement(_ItemPool.default, {
      sizeX: 2,
      sizeY: 4,
      itemPool: {
        sizeX: 2,
        sizeY: 4,
        items: itemToEnhance ? [itemToEnhance] : []
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _CraftingWindowModule.default.name
    }, itemToEnhance && itemToEnhance.model.name));
  }, [itemToEnhance]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CraftingWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _CraftingWindowModule.default.dragHandler,
    classNameCloseBtn: _CraftingWindowModule.default.closeBtn
  }), renderSheet(), renderTool(), renderMaterials(), renderResultingItem(), /*#__PURE__*/_react.default.createElement("div", {
    className: _CraftingWindowModule.default.btnCraft
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CRAFT,
    onClick: handleClickBtnCraft
  }, formatMessage(_CraftingWindow.default.craft))));
}